import { CheckCircleOutline } from '@mui/icons-material';
import { Box, ImageListItem } from '@mui/material';
import React, { useEffect } from 'react';
import { useState } from 'react';
import CircularProgressWithLabel from './CircularProgressWithLabel';
import uploadFileWithProgress from '../uploadFileWithProgress';
import { useParams } from 'react-router-dom';
import { doc, serverTimestamp, setDoc, updateDoc, getDoc, addDoc, collection } from 'firebase/firestore';
import { db } from '../../../../firebase';

const ProgressItem = ({ file }) => {
  const [progress, setProgress] = useState(0);
  const [img, setImg] = useState(null);
  const { userId } = useParams();

  useEffect(() => {
    const uploadImage = async () => {
      const docRef = doc(db, 'users', userId);
      const docSnap = await getDoc(docRef);
      const admin_image =
        'https://firebasestorage.googleapis.com/v0/b/imafeel-db.appspot.com/o/profileIcon_m8nm4pqa3q551.jpg?alt=media&token=0cf70a0d-c850-4b53-b97f-6458c0e14ff2';
      const imageName = file.name;

      let fileDate = file.lastModifiedDate?.toString().substring(0, 15);
      let newsize = file.size;
      let marker = 1024;
      let decimal = 2;
      let kiloBytes = marker;
      let megaBytes = marker * marker;
      let gigaBytes = marker * marker * marker;

      try {
        const url = await uploadFileWithProgress(file, setProgress);
        const data = {
          img: url,
          photo_title: imageName,
          user_Id: userId,
          timeStamp: serverTimestamp(),
          user: docSnap.data().email,
        };
        if (!fileDate) {
          fileDate = data.date;
        }
        if (!file.size) {
          newsize = data.size;
        } else if (file.size < kiloBytes) {
          newsize = file.size;
        } else if (file.size < gigaBytes) {
          newsize = (file.size / megaBytes).toFixed(decimal);
        } else {
          newsize = (file.size / gigaBytes).toFixed(decimal);
        }
        data.size = newsize;
        data.date = fileDate;

        const addPhoto = docSnap.data().photos_nr + 1;

        if (docSnap.data().space >= 101) {
          const minusSpace = docSnap.data().space.toFixed(2) - newsize;
          await setDoc(doc(db, 'users', userId, 'photos', imageName), {
            ...data,
            size: Number(newsize),
          });
          await setDoc(doc(db, 'photos', imageName), {
            ...data,
            size: Number(newsize),
          });
          await updateDoc(doc(db, 'users', userId), {
            photos_nr: Number(addPhoto),
            space: minusSpace,
          });
        }

        if (docSnap.data().space <= 100) {
          const minusSpace = docSnap.data().space.toFixed(2) - newsize;
          await setDoc(doc(db, 'users', userId, 'photos', imageName), {
            ...data,
            size: Number(newsize),
          });
          await setDoc(doc(db, 'photos', imageName), {
            ...data,
            size: Number(newsize),
          });
          await updateDoc(doc(db, 'users', userId), {
            photos_nr: Number(addPhoto),
            space: minusSpace,
          });
          await addDoc(collection(db, 'users', userId, 'notifications'), {
            from: 'Administrator',
            title: '90% of storage used',
            desc: 'We notice you used 90% of your space, to continue uploading photos try to clear some space',
            img: admin_image,
            isCheck: false,
            timeStamp: serverTimestamp(),
          });
        }

        if (docSnap.data().space <= 50) {
          const minusSpace = docSnap.data().space.toFixed(2) - newsize;
          await setDoc(doc(db, 'users', userId, 'photos', imageName), {
            ...data,
            size: Number(newsize),
          });
          await setDoc(doc(db, 'photos', imageName), {
            ...data,
            size: Number(newsize),
          });
          await updateDoc(doc(db, 'users', userId), {
            photos_nr: Number(addPhoto),
            space: minusSpace,
          });
          await addDoc(collection(db, 'users', userId, 'notifications'), {
            from: 'Administrator',
            title: '95% of storage used',
            desc: 'We notice you used 95% of your space, to continue uploading photos try to clear some space',
            img: admin_image,
            isCheck: false,
            timeStamp: serverTimestamp(),
          });
        }
        if (docSnap.data().space < 1) {
          await addDoc(collection(db, 'users', userId, 'notifications'), {
            from: 'Administrator',
            title: '100% of storage used',
            desc: 'We notice you used ALL of your space, to continue uploading photos try to clear some space',
            img: admin_image,
            isCheck: false,
            timeStamp: serverTimestamp(),
          });
        }

        setImg(null);
      } catch (error) {
        alert(error.message);
        console.log(error);
      }
    };

    setImg(URL.createObjectURL(file));

    uploadImage();

    // eslint-disable-next-line
  }, [file]);

  return (
    img && (
      <ImageListItem cols={1} rows={1}>
        <img src={img} alt="images gallery" loading="lazy" />
        <Box sx={backDrop}>
          {progress < 100 ? (
            <CircularProgressWithLabel value={progress} />
          ) : (
            <CheckCircleOutline sx={{ width: 60, height: 60, color: '#7199ff' }} />
          )}
        </Box>
      </ImageListItem>
    )
  );
};

export default ProgressItem;

const backDrop = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0,0,0,.5)',
};
